/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2CalendarUnseatedIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2CalendarUnseatedIcon({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2CalendarUnseatedIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 10,
  height = 10,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#323F4B"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2CalendarUnseatedIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 10 10"
 style={{'--as-1-ZpkCgT': alignSelf,'--mt-2-ZpkCgT': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZpkCgT': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZpkCgT': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZpkCgT': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZpkCgT': opacity,'--w-10-ZpkCgT': typeof width === 'number' ? `${width}px` : width,'--h-11-ZpkCgT': typeof height === 'number' ? `${height}px` : height,'--f-12-ZpkCgT': fill,'--a-7-ZpkCgT': isAnimated ? animation : "none",'--sd-8-ZpkCgT': isAnimated ? strokeDashoffset : 0,'--sd-9-ZpkCgT': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2CalendarUnseatedIcon.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M3.152.548a.548.548 0 10-1.096 0v3.737h1.096v-.641h5.067v1.492H5.686V8.468l2.086 1.434a.548.548 0 10.62-.903l-1.74-1.196 2.285-1.571h.515a.548.548 0 100-1.096h-.137V.548a.548.548 0 00-1.096 0H3.152zM2.5 9.998A2.5 2.5 0 102.5 5a2.5 2.5 0 000 5zM3.53 7.1a.446.446 0 00-.632-.631l-.714.714a.446.446 0 10.631.631L3.53 7.1z"
 style={{'--f-12-ZpkCgT': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}